import { TokenEngine } from "@vp/vp-js-token-engine";
import { RangedAttributeValidationCode, } from "../../../../types";
export const getHelperText = (i18n, i18nUnsafe, rangeInformation, unitOfMeasure) => {
    const isBooklets = isBookletsUnits(unitOfMeasure);
    const maximum = getMaximumValue(rangeInformation);
    const minimum = getMinimumValue(rangeInformation);
    const fullHelperText = isBooklets
        ? i18nUnsafe("fullRangedHelperTextForBooklets")
        : i18n("fullRangedHelperText");
    const partialHelperText = isBooklets
        ? i18nUnsafe("rangePartialRangedHelperTextForBooklets")
        : i18n("rangePartialRangedHelperText");
    const tokenEngine = new TokenEngine();
    let helperText;
    if (fullHelperText && maximum.isFinite()) {
        helperText = tokenEngine.replace(fullHelperText, {
            MINIMUM: minimum,
            UNIT: unitOfMeasure,
            MAXIMUM: maximum,
        });
    }
    else if (partialHelperText) {
        helperText = tokenEngine.replace(partialHelperText, {
            MINIMUM: minimum,
            UNIT: unitOfMeasure,
        });
    }
    return { helperText };
};
export const getValidationMessage = (props) => {
    const { isConstrained, validationCode, additionalInformation, rangeInformation, unitOfMeasure, i18n, i18nUnsafe, } = props;
    if (isConstrained) {
        const outOfStock = i18n("outOfStockCallout");
        return outOfStock;
    }
    switch (validationCode) {
        case RangedAttributeValidationCode.EMPTY_INPUT: {
            return getValidationMessageForRequiredField(i18n, i18nUnsafe, getMinimumValue(rangeInformation), getMaximumValue(rangeInformation), unitOfMeasure);
        }
        case RangedAttributeValidationCode.SUCCESS: {
            return "";
        }
        case RangedAttributeValidationCode.NOT_IN_RANGE: {
            return getValidationMessageWithNearestNumber(i18n, i18nUnsafe, additionalInformation?.adjacentValues, unitOfMeasure);
        }
        case RangedAttributeValidationCode.UNSUPPORTED_PRECISION: {
            return i18n("rangedDecimalPrecisionError");
        }
        case RangedAttributeValidationCode.NOT_A_NUMBER: {
            return i18n("rangedNotANumberError");
        }
        case RangedAttributeValidationCode.UNKNOWN_ERROR:
        default: {
            return i18n("rangedGeneralInputError");
        }
    }
};
const getValidationMessageForRequiredField = (i18n, i18nUnsafe, minimum, maximum, unitOfMeasure) => {
    const isBooklets = isBookletsUnits(unitOfMeasure);
    const requiredAttributeFieldError = isBooklets
        ? i18nUnsafe("requiredAttributeFieldErrorForBooklets")
        : i18n("requiredAttributeFieldError");
    const tokenEngine = new TokenEngine();
    const message = tokenEngine.replace(requiredAttributeFieldError ?? "", {
        LOWER: minimum,
        UNIT: unitOfMeasure,
        HIGHER: maximum,
    });
    return message;
};
const getValidationMessageWithNearestNumber = (i18n, i18nUnsafe, adjacentValues, unitOfMeasure) => {
    const isBooklets = isBookletsUnits(unitOfMeasure);
    if (!adjacentValues || (!adjacentValues.lowerAdjValue && !adjacentValues.upperAdjValue)) {
        const validationEntry = i18n("rangedGeneralInputError");
        return validationEntry;
    }
    const { lowerAdjValue, upperAdjValue } = adjacentValues;
    const tokenEngine = new TokenEngine();
    let message;
    let entry;
    if (lowerAdjValue && !upperAdjValue) {
        entry = isBooklets
            ? i18nUnsafe("rangedMaxInputValueErrorForBooklets")
            : i18n("rangedMaxInputValueError");
        message = tokenEngine.replace(entry ?? "", {
            MAXIMUM: lowerAdjValue,
            UNIT: unitOfMeasure,
        });
    }
    else if (!lowerAdjValue && upperAdjValue) {
        entry = isBooklets
            ? i18nUnsafe("rangedMinInputValueErrorForBooklets")
            : i18n("rangedMinInputValueError");
        message = tokenEngine.replace(entry ?? "", {
            MINIMUM: upperAdjValue,
            UNIT: unitOfMeasure,
        });
    }
    else {
        entry = isBooklets
            ? i18nUnsafe("rangedBetweenRangesErrorForBooklets")
            : i18n("rangedBetweenRangesError");
        message = tokenEngine.replace(entry ?? "", {
            LOWER: lowerAdjValue,
            HIGHER: upperAdjValue,
            UNIT: unitOfMeasure,
        });
    }
    return message;
};
const getMaximumValue = (rangeInformation) => {
    return rangeInformation
        .getRanges()
        .reduce((currentMax, currentRange) => currentMax.getMaximum().greaterThan(currentRange.getMaximum()) ? currentMax : currentRange)
        .getMaximum();
};
const getMinimumValue = (rangeInformation) => {
    return rangeInformation
        .getRanges()
        .reduce((currentMin, currentRange) => currentMin.getMinimum().lessThan(currentRange.getMinimum()) ? currentMin : currentRange)
        .getMinimum();
};
const isBookletsUnits = (unitOfMeasure) => {
    return unitOfMeasure?.toLowerCase() === "pages";
};
//# sourceMappingURL=getRangeMessages.js.map